module.exports = __webpack_public_path__ + "e78eff53d34a3f0a96024dcfdbda306e.MP3";